module.exports = __webpack_public_path__ + "img/Proliferation-ASHN_GSE227469.5cc8d702.png";